var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('lak-druh-select',{attrs:{"value":_vm.LakdruhOzn,"text":_vm.LakdruhOznText,"mutation-name":_vm.mutationsMappers.mutationName,"filter":_vm.lakdruhFilter}})}
var staticRenderFns = []

export { render, staticRenderFns }